module.exports = __webpack_public_path__ + "img/Frente-51-00 off.f5136c4d.png";